import { Component } from "solid-js";

interface AllBrandsIconProps {
  class?: string;
}

export const AllBrandsIcon: Component<AllBrandsIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.51476 7.51469V7.51469C12.2014 2.82803 19.7988 2.82803 24.4854 7.51469V7.51469C29.1721 12.2014 29.1721 19.7987 24.4854 24.4854V24.4854C19.7988 29.172 12.2014 29.172 7.51476 24.4854V24.4854C2.82809 19.7987 2.82809 12.2014 7.51476 7.51469Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5387 20.676L12.0534 13.1C12.16 12.572 12.572 12.16 13.1 12.0547L20.676 10.54C21.1427 10.4467 21.5534 10.8573 21.46 11.324L19.9454 18.9C19.84 19.428 19.4267 19.84 18.9 19.9453L11.324 21.46C10.8574 21.5547 10.4454 21.1427 10.5387 20.676Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.9988 15.6666C15.8148 15.6666 15.6655 15.816 15.6668 16C15.6668 16.184 15.8162 16.3333 16.0002 16.3333C16.1842 16.3333 16.3335 16.184 16.3335 16C16.3335 15.816 16.1842 15.6666 15.9988 15.6666"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
